export const isOfferExpired = (expirationDate: string | null | undefined) => {
  if (!expirationDate) {
    return false;
  }

  try {
    return new Date() >= new Date(expirationDate);
  } catch {
    return false;
  }
};
